module.exports = __webpack_public_path__ + "static/media/YM56_2.6bbe0c1d.jpg";